export default "__VITE_ASSET__C0jsZmE9__"